var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"score-input"},[_vm._l((_vm.options),function(i,index){return _c('button',{key:index,staticClass:"clearfix far fa-heart",class:{
            lower: _vm.isLower(i),
            greater: _vm.isGreater(i),
            active: _vm.isActive(i),
        },on:{"click":function($event){$event.preventDefault();return _vm.setValue(i)}}},[_vm._t("button-content"),_vm._v(" "),_c('span',{staticClass:"score-number"},[_vm._v(_vm._s(i))])],2)}),_vm._v(" "),_c('input',{ref:"input",attrs:{"type":"hidden"},domProps:{"value":_vm.value}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }